import { useEffect } from "react";

/**
 * Lightweight per-route SEO manager.
 * Updates <title>, <meta name="description"> and <link rel="canonical">
 * plus OpenGraph/Twitter tags — creates them if missing.
 */
export default function SEO({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, val) => {
      if (!val) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }

    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }

    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");

    // Canonical
    let canonicalUrl = null;
    try {
      const origin = window.location.origin;
      canonicalUrl = path ? `${origin}${path}` : window.location.href.split("?")[0].split("#")[0];
    } catch {}
    if (canonicalUrl) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
      setMeta("property", "og:url", canonicalUrl);
    }
  }, [title, description, path]);

  return null;
}
